<template>
  <navbar
    position="fixed"
    type="primary"
    :transparent="transparent"
    :color-on-scroll="colorOnScroll"
    menu-classes="ml-auto"
  >
    <template>
      <router-link class="navbar-brand" to="/">
        <img class="navbar-imglogo" src="img/Logo_Gateway.png" alt="">
      </router-link>
    </template>
    <template slot="navbar-menu">
      <li class="nav-item">
       <nav-link class="nav-link" to="/">
        <p>INICIO</p>
        </nav-link>
      </li>
      <li class="nav-item">
       <nav-link class="nav-link" to="/productos">
        <p>PRODUCTOS</p>
        </nav-link>
      </li>
     
      <li class="nav-item">
        <nav-link class="nav-link carrito" to="/carrito">
          <i class="fas fa-shopping-cart fa-2x"></i>
          <p class="d-lg-none d-xl-none">Carrito de Compras</p>
         </nav-link>
      </li>
       <li class="nav-item">
       <a
          class="nav-link"
          href="https://gatewayit.com.co"
          target="_blank"
        >
       <i class="iconglobe fas fa-globe fa-2x"></i>
          <p class="d-lg-none d-xl-none">Carrito de Compras</p>
        </a>
      </li>
     
    </template>
  </navbar>
</template>

<script>
import { Navbar, NavLink } from '@/components';
export default {
  name: 'main-navbar',
  props: {
    transparent: Boolean,
    colorOnScroll: Number
  },
  components: {
    Navbar,
    NavLink,
  }
};
</script>

<style scoped>
.carrito{
  color:#fff;
}
.navbar-imglogo{width: 150px;}
.iconglobe{
  font-size:15px;
}
</style>
